export const LOGIN_PAGE = "/login";

// Полный переход с перезагрузкой страницы. Отдельный модуль, чтобы тесты могли его подменить:
// jsdom не умеет `location.assign`.
export const leavePage = (url: string): void => {
  window.location.assign(url);
};
